import type { UserPublicProfile } from '@user/PublicProfile';
import { generateDefaultUserIcon } from '@framework/utils';

const Constants = {
  avatar: {
    padding: 6,
    width: 36,
    height: 36,
  },
};

type Props = {
  author: UserPublicProfile;
  postAt: string;
  rightMenu?: React.ReactNode;
};

export const ModelCommentHeader: React.FC<Props> = ({ author, postAt, rightMenu }: Props) => {
  return (
    <div className="mb-2 flex items-center">
      <div
        style={{
          padding: Constants.avatar.padding,
          width: Constants.avatar.width + Constants.avatar.padding * 2,
          height: Constants.avatar.height + Constants.avatar.padding * 2,
        }}
      >
        {author.imageUrl ? (
          <img
            className="max-w-none rounded-full bg-neutral-300 object-cover"
            src={author.imageUrl}
            alt={author.name}
            style={{ width: Constants.avatar.width, height: Constants.avatar.height }}
          />
        ) : (
          <div
            className="max-w-none overflow-hidden rounded-full bg-neutral-300 object-cover"
            style={{ width: Constants.avatar.width, height: Constants.avatar.height }}
          >
            {generateDefaultUserIcon({
              id: author.id,
              name: author.name,
              isAnonymous: author.isAnonymous,
              size: Constants.avatar.width,
            })}
          </div>
        )}
      </div>
      <div className="overflow-hidden text-ellipsis pl-[6px] text-3xl font-bold">{author.name}</div>
      <div className="pl-6 text-2xl text-gray-600">{postAt}</div>
      {rightMenu && <div className="ml-auto">{rightMenu}</div>}
    </div>
  );
};
